var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18.1,
    viewBox: "0 0 18 18.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Dashboard",
    d: "M9.9,3H4.6A1.58,1.58,0,0,0,3,4.6v8.5a1.58,1.58,0,0,0,1.6,1.6H9.9a1.58,1.58,0,0,0,1.6-1.6V4.6A1.58,1.58,0,0,0,9.9,3Zm-.5,9.5H5.1V5.1H9.3v7.4Zm.5,3.2H4.6A1.58,1.58,0,0,0,3,17.3v2.1A1.58,1.58,0,0,0,4.6,21H9.9a1.58,1.58,0,0,0,1.6-1.6V17.3A1.58,1.58,0,0,0,9.9,15.7Zm-.5,3.2H5.1V17.8H9.3v1.1Zm10-9.5H14.1A1.58,1.58,0,0,0,12.5,11v8.5a1.58,1.58,0,0,0,1.6,1.6h5.3A1.58,1.58,0,0,0,21,19.5V11A1.58,1.58,0,0,0,19.4,9.4Zm-.5,9.5H14.7V11.5h4.2ZM19.4,3H14.1a1.58,1.58,0,0,0-1.6,1.6V6.7a1.58,1.58,0,0,0,1.6,1.6h5.3A1.58,1.58,0,0,0,21,6.7V4.6A1.58,1.58,0,0,0,19.4,3Zm-.5,3.2H14.7V5.1h4.2Z",
    transform: "translate(-3 -3)",
    fill: "#36c96d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard_icon.df8065e786f196a849e778574a69d685.svg";
export { ForwardRef as ReactComponent };